import { ICommonTable, TCommonTableCell } from 'common/interfaces/objects-interfaces';
import { IObject } from 'common/interfaces/hierarchy-entities';

import { getRawBlob, downloadBlob } from 'client/api-utils';
import { transposeTable } from 'common/table-viewer/utils';

const unParseTableArray = (dataObject: (number | string)[][], sepOne = '\t', sepTwo = '\n') => {
  return dataObject.map((row) => row.join(sepOne)).join(sepTwo);
};

export const formatObjectLikeDataToSimpleFormatFunctor = (r: TCommonTableCell[]) => {
  return r.map(c => {
    if (typeof c === 'object' && 'value' in c) {
      // @ts-ignore
      return c.value;
    }
    return c;
  });
};

export const parseText = (
  exportData: ICommonTable,
  isVertical = false,
) => {
  const data = [exportData.headers, ...exportData.rows.map(formatObjectLikeDataToSimpleFormatFunctor)];
  if (isVertical) {
    data.push(exportData.units);
  } else {
    data.splice(1, 0, exportData.units);
  }
  const transposedData = transposeTable(data);
  const text = unParseTableArray(isVertical ? transposedData : data);
  return text;
};

export const downloadTableArray = (
  exportData: ICommonTable,
  name: string,
  isVertical = false,
) => {
  const text = parseText(exportData, isVertical);
  const blob = new Blob([text], { type: 'text/plain' });
  const fileName = name.concat('.csv');
  const url = window.URL.createObjectURL(blob);
  downloadBlob(url, fileName);
};

const getObjectBlobData = async (object: IObject) => {
  const result = {
    blob: null,
    fileName: null,
  } as { blob: Blob | null; fileName: string | null; };
  if (object.data) {
    result.blob = new Blob([JSON.stringify(object.data)], { type: 'application/json' });
    result.fileName = object.name.concat('.json');
  } else if (object.metadata.blobData.blobNameOriginal) {
    const response = await getRawBlob(object.metadata.blobData.blobNameOriginal);
    result.blob = new Blob([response.data], { type: object.metadata.file.mimetype });
    result.fileName = object.metadata.file.name;
  }
  return result as { blob: Blob; fileName: string; };
};

export const downloadObject = async (object: IObject) => {
  const blobData = await getObjectBlobData(object);
  const url = window.URL.createObjectURL(blobData.blob);
  downloadBlob(url, blobData.fileName);
};

export const getObjectBlobUrl = async (object: IObject) => {
  const blobData = await getObjectBlobData(object);
  const url = window.URL.createObjectURL(blobData.blob);
  return url;
};